export default __webpack_public_path__ + "static/media/ep2collage3.ed8ae7d5.jpg";